import { AgentsAiChatIcon, Icon, type IconProps } from '@grammarly/design-system'
import { SuperhumanGoIcon } from './SuperhumanGoIcon'
import { CHAT_AGENT_TITLE, SUPERHUMAN_GO_TITLE } from '../utils/constants'

type ChatAgentIconProps = {
  /** Defaults to ChatAgentTitle exported from this package */
  accessibilityLabel?: string
  goBrandingEnabled?: boolean
  size: IconProps['size']
}

export const ChatAgentIcon = ({
  size,
  accessibilityLabel,
  goBrandingEnabled,
}: ChatAgentIconProps) => {
  if (goBrandingEnabled) {
    return (
      <Icon
        size={size}
        icon={SuperhumanGoIcon}
        accessibilityLabel={accessibilityLabel ?? SUPERHUMAN_GO_TITLE}
      />
    )
  }
  return (
    <Icon
      size={size}
      icon={AgentsAiChatIcon}
      accessibilityLabel={accessibilityLabel ?? CHAT_AGENT_TITLE}
    />
  )
}
